<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      :items-per-page="5"
      :search="search"
      sort-by="calories"
      class="elevation-1 mb-10"
      style="cursor: pointer;"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>
            <b>{{ $t(title) }}</b>
          </v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <div class="search-bar">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('table.search')"
              single-line
              hide-details
            ></v-text-field>
          </div>
          <v-spacer></v-spacer>

          <div class="text-center mr-5">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <a
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  style="text-decoration: underline;"
                >{{ $t('table.export') }}</a>
              </template>
              <v-list>
                <!-- Need to include click action to have hover animation -->
                <JsonExcel :data="items" :fields="exportFields" type="csv" :name="title +'.csv'">
                  <v-list-item @click="onExportCsv()">
                    <v-list-item-title>CSV</v-list-item-title>
                  </v-list-item>
                </JsonExcel>

                <v-list-item @click="onExportPdf()">
                  <!-- Need to include click action to have hover animation -->
                  <v-list-item-title>PDF</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>

          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                tile
                dark
                class="mb-2 primary-color"
                v-bind="attrs"
                v-on="on"
                @click="addItem()"
              >
                {{ $t('table.add') }}
                <v-icon size="20" class="ml-1">mdi-plus</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }} {{ $t(title) }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col md="12">
                      <v-text-field v-model="editedItem.name" :label="modalText + '\'s Name*'"></v-text-field>
                    </v-col>
                    <v-col md="12">
                      <v-text-field
                        v-model="editedItem.code"
                        v-if="title=='Country'"
                        label="Country Code"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" tile text @click="dialog = false;">Cancel</v-btn>
                <v-btn
                  color="blue darken-1"
                  tile
                  text
                  @click="dialog = false; onConfirmAction();"
                >Confirm</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              size="20"
              class="mr-1"
              v-bind="attrs"
              v-on="on"
              @click="editItem(item)"
            >mdi-pencil</v-icon>
          </template>
          <span>{{ $t('table.edit') }}</span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              size="20"
              class="ml-1"
              v-bind="attrs"
              v-on="on"
              @click.stop="deleteItem(item)"
            >mdi-delete</v-icon>
          </template>
          <span>{{ $t('table.delete') }}</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import JsonExcel from "vue-json-excel";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  components: {
    JsonExcel,
  },
  props: {
    headers: Array,
    items: Array,
    title: String,
    btnText: String,
    routeTo: String,
    apiRoute: String,
    modalText: String,
  },
  data: () => ({
    search: "",
    dialog: false,
    deleteDialog: false,
    editedIndex: -1,
    editedItem: {},
    onConfirmAction: null,
    pdfWidth: null,
    pdfData: null,
    pdfHeader: [
      { text: "Name", style: "tableHeader" },
      { text: "Country Code", style: "tableHeader" },
    ],
    exportFields: null,
  }),
  mounted: function () {
    if (this.title == "country.country") {
      this.exportFields = {
        Name: "name",
        Code: "code",
        "Updated At": "updatedAt",
      };
    } else {
      this.exportFields = {
        Name: "name",
        "Updated At": "updatedAt",
      };
    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? `Add ` : `Edit`;
    },
  },
  methods: {
    addItem() {
      this.editedIndex = -1;
      this.editedItem = {};
      this.onConfirmAction = this.onAddOptions;
    },
    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.onConfirmAction = this.onEditOption;
      this.dialog = true;
    },
    deleteItem(item) {
      const confirmDelete = window.confirm(
        `Are you sure to delete ${item.name}?`
      );
      if (confirmDelete) {
        this.onDeleteOption(item._id);
      }
    },
    onAddOptions: function () {
      const data = { name: this.editedItem.name, code: this.editedItem.code };

      fetch(`${process.env.VUE_APP_ROOT_API}/${this.apiRoute}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((data) => {
          const feedbackData = { title: this.apiRoute, message: data.message };
          this.$emit("optionAdded", feedbackData);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    onEditOption: function () {
      const data = { name: this.editedItem.name, code: this.editedItem.code };

      fetch(
        `${process.env.VUE_APP_ROOT_API}/${this.apiRoute}/${this.editedItem._id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.$store.state.jwt}`,
          },
          body: JSON.stringify(data),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          const feedbackData = { title: this.apiRoute, message: data.message };
          this.$emit("optionAdded", feedbackData);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    onDeleteOption: function (id) {
      fetch(`${process.env.VUE_APP_ROOT_API}/${this.apiRoute}/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          const feedbackData = { title: this.apiRoute, message: data.message };
          this.$emit("optionAdded", feedbackData);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    onExportCsv: function () {
      console.log("Exporting csv...");
    },
    onExportPdf: function () {
      // define PDF body depends on the data to be displayed
      this.pdfData = this.items.map((item) => {
        if (item.code) {
          return [item.name, item.code]; // for country data
        } else {
          return [item.name]; // for others
        }
      });

      // define PDF header depends on the body data
      for (let i = 0; i < this.items.length; i++) {
        if (i == 0) {
          if (this.items[i].code) {
            this.pdfWidth = ["*", "*"];
            this.pdfHeader = [
              { text: "Name", style: "tableHeader" },
              { text: "Country Code", style: "tableHeader" },
            ];
          } else {
            this.pdfWidth = ["*"];
            this.pdfHeader = [{ text: "Name", style: "tableHeader" }];
          }
          break;
        }
      }

      this.pdfData.unshift(this.pdfHeader);

      var doc = {
        content: [
          { text: `${this.title} List`, style: "header" },
          {
            style: "tableExample",
            table: {
              headerRows: 1,
              body: this.pdfData,
            },
          },
        ],
        styles: {
          header: {
            fontSize: 18,
            bold: true,
            margin: [0, 0, 0, 10],
          },
          subheader: {
            fontSize: 16,
            bold: true,
            margin: [0, 10, 0, 5],
          },
          tableExample: {
            margin: [0, 5, 0, 15],
          },
          tableHeader: {
            bold: true,
            fontSize: 13,
            color: "black",
          },
        },
      };
      pdfMake.createPdf(doc).open();
    },
  },
};
</script>

<style scoped>
.search-bar {
  width: 200px;
}
</style>